import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TESTID } from "@/lib/testIds";
import { ShieldCheck, AlertCircle, ArrowRight } from "lucide-react";

export default function MfaChallengePage() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { verifyMfa, mfaPending } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await verifyMfa(code);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-armada-base flex items-center justify-center px-6 py-12">
      <div className="absolute inset-0 dashboard-grid opacity-30 pointer-events-none" />
      <div className="relative w-full max-w-[440px] glass-strong rounded-2xl p-10 animate-fade-up">
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center animate-pulse-gold">
            <ShieldCheck className="w-7 h-7 text-[#D4AF37]" />
          </div>
        </div>
        <div className="text-center mb-6">
          <div className="text-[10px] tracking-armada text-[#D4AF37] font-bold mb-2">PHASE 1 ARMOR HARDENING</div>
          <h1 className="text-2xl font-black text-white tracking-tight">Two-Factor Required</h1>
          <p className="text-sm text-zinc-400 mt-2 font-light">
            {mfaPending?.user ? `Hello ${mfaPending.user.full_name}, ` : ""}
            Enter the 6-digit code from your Authenticator app.
          </p>
        </div>

        {error && (
          <div data-testid={TESTID.mfaError} className="mb-4 flex items-start gap-2 p-3 rounded-md bg-red-950/40 border border-red-900/50 text-red-200 text-sm">
            <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" /><span>{error}</span>
          </div>
        )}

        <form onSubmit={submit} className="space-y-5">
          <input
            data-testid={TESTID.mfaCodeInput}
            inputMode="numeric"
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\s/g, ""))}
            placeholder="000000"
            maxLength={9}
            className="armada-input text-center text-2xl tracking-[0.5em] font-mono"
          />
          <button
            data-testid={TESTID.mfaSubmit}
            type="submit"
            disabled={loading || code.length < 6}
            className="btn-gold w-full flex items-center justify-center gap-2"
          >
            {loading ? "Verifying…" : "Verify Code"}
            <ArrowRight className="w-4 h-4" />
          </button>
          <p className="text-center text-[11px] text-zinc-500">
            Lost device? Use one of your 8-character backup codes.
          </p>
        </form>
      </div>
    </div>
  );
}
